import { css } from '@emotion/css';

export const contentStyles = css`
  :last-of-type .content {
    border: none !important;
  }
`;

export const hoverContentStyles = css`
  :last-of-type .content {
    border: none !important;
  }
  :hover :not(.disabled).content {
    box-shadow: 0px -1px 0px 0px var(--bg-primary);
    border-color: transparent !important;
  }
`;
